import { createSlice, current } from "@reduxjs/toolkit";

export const initialState = {
  sharepoint_creds:{
    bot_id: null,
    client_id: null,
    client_secret: null,
    site_name: null,
    site_url: null,
    tenant_id: null
  },
  loading:false,
  share_point_root_file:null

};

const Sharepoint = createSlice({
  name: "share_point",
  initialState,
  reducers: {
    set_sharepoint_creds(state, action) {
      state.sharepoint_creds = action.payload
     
    },
    set_sharepoint_loader(state, action){
        state.loading = action.payload
    },

     set_sharepoint_root_files(state, action){
        state.share_point_root_file=action.payload

    },

     reset_Share_Point_Details: () => initialState, // 🔥 Reset everything to the initial state


 
 
  },
});

export const {
  set_sharepoint_creds,
  set_sharepoint_loader,
  set_sharepoint_root_files,
  reset_Share_Point_Details
} = Sharepoint.actions

export default Sharepoint.reducer;